// App level error screen (screens QA SQ-2, 4 Nov 2026).
// Without it any error while drawing a screen (for example a table sort on an empty value)
// unmounted the whole app and left a white page. Now the fault shows a message with a way back.
// resetKey: when it changes (the page path), the boundary clears so moving to another page works.
import React, { Component } from "react";
import { Button, Result } from "antd";
import i18n from "lang";

const t = (key, fallback) => {
  try {
    const v = i18n.t(key);
    return v && v !== key ? v : fallback;
  } catch (e) {
    return fallback;
  }
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Screen error:", error, info && info.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  handleTryAgain = () => {
    this.setState({ hasError: false });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <Result
        status="warning"
        title={t("SomethingWentWrong", "Something went wrong!")}
        extra={[
          <Button key="again" type="primary" onClick={this.handleTryAgain}>
            {t("TryAgain", "Try Again")}
          </Button>,
          <Button key="reload" onClick={this.handleReload}>
            {t("Refresh", "Refresh")}
          </Button>,
        ]}
      />
    );
  }
}

export default ErrorBoundary;
